import React from 'react'
import { curry } from 'lodash'
import { connect } from 'react-redux'
import Dialog from 'react-toolbox/lib/dialog'
import { branch, compose, renderComponent } from 'recompose'

const filters = curry((filters, WrappedComponent) => {
  return class FilterStatusHoc extends React.Component {
    // Make sure all selected filters have count to be = 0 for isDone = true
    // this makes sure that some action is still processing
    isDone(){
      return !this.isLoading(this.props.actions)
    }

    // If chosen filters are still waiting for response than return true
    isLoading(){
      return Object
        .entries(this.props.actions)
        .some(([key, value]) =>
          (value > 0) && filters.some((filter) => filter === key)
        )
    }

    render() {
      let {
        actions,
        ...rest
      } = this.props

      return <WrappedComponent {...rest} loading={this.isLoading()}/>
    }
  }
})


const filterHoc = curry((Component, filterList) => {
  const mapStateToProps = (state) => {
    return {
      actions: state.asyncActions
    }
  }

  const withFilters = filters(filterList)
  const withConnect = connect(mapStateToProps)
  const enhance = compose(
    withConnect,
    withFilters,
  )

  return enhance(Component)
})

const loading = (Progress) => compose(
  filterHoc,
  branch(
    ({ loading }) => loading,
    renderComponent(Progress)
  )
)

export {
  loading
}
export default filterHoc
